import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="hero" data-id="element-77">
      <div className="hero-inner" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: -16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="hero-label" data-id="element-79">
          Workshop Grabado · Acceso de por Vida
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 32
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9
      }} data-id="element-80">
          Aprende a Crear tu Propia Página Web Profesional{' '}
          <span className="accent" data-id="element-81">con IA.</span>
        </motion.h1>

        <motion.p className="sub" initial={{
        opacity: 0,
        y: 32
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.15
      }} data-id="element-82">
          Sin saber código. Sin contratar diseñador. Te enseño paso a paso cómo
          usar inteligencia artificial para construir una página que se vea de
          $5,000 — en una sola tarde.
        </motion.p>

        <motion.div className="cta-group" initial={{
        opacity: 0,
        y: 32
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.3
      }} data-id="element-83">
          <a href="https://sharontirado.mykajabi.com/offers/JCeY2FLo" target="_blank" rel="noopener noreferrer" className="cta-btn" data-id="element-84">
            QUIERO APRENDER — $37
          </a>
        </motion.div>

        <motion.p className="meta" initial={{
        opacity: 0,
        y: 32
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.45
      }} data-id="element-85">
          100% en Español · Workshop grabado listo para ver hoy · Template
          incluido
        </motion.p>
      </div>
    </section>;
}